import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const GUEST_TOKEN_KEY = "jow_guest_token";

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("jow_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  const guestToken = localStorage.getItem(GUEST_TOKEN_KEY);
  if (guestToken) {
    config.headers["X-Guest-Token"] = guestToken;
  }
  return config;
});

api.interceptors.response.use((res) => {
  const echoed = res.headers?.["x-guest-token"];
  if (echoed && echoed !== localStorage.getItem(GUEST_TOKEN_KEY)) {
    localStorage.setItem(GUEST_TOKEN_KEY, echoed);
  }
  return res;
});

export const clearGuestToken = () => localStorage.removeItem(GUEST_TOKEN_KEY);

export default api;
